import React from "react";
import { Link } from "react-router-dom";
import { SERVICES } from "../lib/services";
import { ArrowUpRight } from "lucide-react";
import { smoothScrollHash } from "../lib/smoothScroll";

export default function ServicesGrid() {
  return (
    <section id="services" className="border-b border-black/10 bg-white" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-8">
          <div>
            <p className="text-xs font-semibold tracking-[0.22em] uppercase text-[#EAB308]">
              [ 01 ] Services
            </p>
            <h2 className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-4 max-w-3xl">
              Everything your Startup needs — under one roof.
            </h2>
          </div>
          <p className="text-black/70 md:text-right max-w-sm text-base">
            No more juggling <strong className="font-bold text-black">multiple</strong> different vendors. Browse the catalog — get
            matched with vetted specialists.
          </p>
        </div>

        <div
          className="mb-10 flex flex-wrap items-center gap-x-3 gap-y-2 border-l-2 border-[#EAB308] pl-4 text-sm sm:text-base text-black/75"
          data-testid="services-audience-callout"
        >
          <span>
            <strong className="font-bold text-black">Based in India or abroad?</strong>{" "}
            We handle standard Indian founder setups <span className="text-black/40">·</span>{" "}
            resident-director + GST + compliance flows, and full remote NRI incorporations with
            apostilled documents and FEMA / RBI handling.
          </span>
          <Link
            to="/nri"
            data-testid="services-nri-link"
            className="font-semibold text-[#EAB308] underline underline-offset-4 decoration-2 hover:text-black transition-colors whitespace-nowrap"
          >
            See our NRI playbook →
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s) => (
            <ServiceCard key={s.id} service={s} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ServiceCard({ service }) {
  const { id, title, short, description, bullets, Icon } = service;

  return (
    <a
      href="#lead-form"
      onClick={smoothScrollHash}
      data-testid={`service-card-${id}`}
      className="group relative border border-black/80 bg-white text-black p-6 sm:p-8 flex flex-col min-h-[360px] transition-all duration-200 hover:-translate-y-1 hover:neo-shadow-sm"
    >
      <div className="flex items-start justify-between">
        <div className="w-11 h-11 flex items-center justify-center border border-black/80 bg-white">
          <Icon size={20} />
        </div>
        <ArrowUpRight
          size={20}
          className="opacity-60 group-hover:opacity-100 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
        />
      </div>

      <div className="mt-6 flex-1">
        <p className="text-[11px] tracking-[0.18em] uppercase text-black/60">
          {short}
        </p>
        <h3 className="font-heading font-black text-2xl sm:text-[28px] mt-2 leading-tight">
          {title}
        </h3>
        <p className="mt-3 text-sm leading-relaxed text-black/70">
          {description}
        </p>
      </div>

      <ul className="mt-6 space-y-2 pt-5 border-t border-black/10">
        {bullets.map((b) => (
          <li key={b} className="flex items-start gap-2 text-xs">
            <span className="mt-1.5 inline-block w-1.5 h-1.5 bg-[#EAB308] shrink-0" />
            <span className="text-black/80">{b}</span>
          </li>
        ))}
      </ul>
    </a>
  );
}
